import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Action } from '@ngrx/store';
import {
  LoginInterface,
  ResponseLoginInterface,
} from '../../interfaces/auth.interface';
import { loginCredentials, requestSuccess, requestError } from './actions';
import { ErrorInterface } from '../../interfaces/general.interface';

@Injectable()
export class LoginCredentialsEffect {
  constructor(
    private router: Router,
    private service: AuthService,
    private actions$: Actions
  ) {}

  public loginCredentials$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(loginCredentials),
      switchMap((payload: { params: LoginInterface }) =>
        this.service.login(payload.params).pipe(
          map((response: ResponseLoginInterface) => {
            if (response.errorCode.code !== 0) {
              if (response.details && typeof response.details === 'string') {
                response.errorCode.details = response.details;
              }
              throw response.errorCode;
            }
            return requestSuccess({ response });
          }),
          catchError((error: ErrorInterface) => of(requestError({ error })))
        )
      )
    );
  });
}
